module.exports = __webpack_public_path__ + "static/img/banner_1.4be6527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/全基因组合成/亚克隆/banner_1.jpg
// module id = Cwfd
// module chunks = 16